import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase, readableError } from '../lib/supabase'
import { Shell } from '../components/Shell'
import { Sill, Spinner } from '../components/ui'
import InvitePanel from '../components/InvitePanel'

/**
 * What the + tab opens. Two things start here: a song, or someone else's
 * account. Both begin with a single tap and neither needs the other screen
 * open first, so they sit side by side instead of one being buried in Me.
 */
export default function Create() {
  const nav = useNavigate()
  const [invite, setInvite] = useState(null) // the referral invite_codes row, once fetched
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  const openInvite = async () => {
    if (invite) return setInvite(null)
    setBusy(true); setErr(null)
    const { data, error } = await supabase.rpc('create_invite_code', { p_kind: 'referral' })
    setBusy(false)
    if (error) return setErr(readableError(error))
    setInvite(data)
  }

  return (
    <Shell tabs>
      <div className="eyebrow">Start something</div>
      <h2 className="q">Write, share an idea, or bring someone in.</h2>
      <Sill />

      <button className="action col" onClick={() => nav('/songs/new')}>
        <div className="row"><span>Write a new song</span><span className="ar">›</span></div>
        <small>Start the wizard — title, key, a first recording</small>
      </button>

      <button className="action col" onClick={() => nav('/create/clip')}
              style={{ marginTop: 10 }}>
        <div className="row"><span>Add a Collective clip</span><span className="ar">›</span></div>
        <small>Twenty seconds of an unfinished idea — the fastest way to be heard</small>
      </button>

      <button className="action col" onClick={openInvite} disabled={busy} aria-busy={busy}
              style={{ marginTop: 10 }}>
        <div className="row"><span>Invite a friend to Beseter</span>
          <span className="ar">{invite ? '−' : '›'}</span></div>
        <small>A code and a QR you send yourself — text, WhatsApp, in person</small>
      </button>

      {busy && !invite && <Spinner />}
      {err && <p className="err">{err}</p>}
      {invite && (
        <div style={{ marginTop: 10 }}>
          <InvitePanel code={invite.code} kind="referral" />
        </div>
      )}
    </Shell>
  )
}
